import { render, staticRenderFns } from "./ModalAddNote.vue?vue&type=template&id=2a1fbbaa&"
import script from "./ModalAddNote.vue?vue&type=script&lang=js&"
export * from "./ModalAddNote.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports